const HelpView = {
    Documentation: "documentation",
    Api: "api",
    // "developer" is the top-level hub that owns the API reference and the
    // CLI reference. "api" is kept as an internal key (item identity, search
    // tagging, markdown generation) even though the route moved to /docs/developer.
    Developer: "developer",
    Cli: "cli"
};

const BasePathLabel = {
    Documentation: "Docs",
    Api: "Api"
};

const HelpItemType = {
    Article: "Article",
    Category: "Category",
    Function: "Function",
    ResourceGroup: "ResourceGroup",
    Resource: "Resource",
    Endpoint: "Endpoint"
};

const SearchType = {
    All: 0
};

const TileType = {
    Subtitle: 1,
    SortingGroup: 2
};

const RelatedItemType = {
    Article: 1,
    External: 2
};

const PopdockScriptTitle = "Popdock script";
const PopdockScriptDescription = "Learn how to write calculated fields using Popdock's built-in scripting language.";

export {
    HelpView,
    HelpItemType,
    SearchType,
    BasePathLabel,
    TileType,
    RelatedItemType,
    PopdockScriptTitle,
    PopdockScriptDescription
};